import { ReactNode } from 'react'
import { Button, EmissionsSummaryPanelModule } from '../../components/BaseComponents'
import { CarbonAccountSummary } from '../../types/CarbonAccountSummary'
import { getCurrencySymbol } from '../../lib/utils'
import useCurrency from '../../hooks/useCurrency'

export type PortfolioListZones = {
	summary: ReactNode
	actions: ReactNode
	table: ReactNode
}

type UsePortfolioListZonesArgs = {
	onCreateClick: () => void
	tableComponent: ReactNode
	isLoading: boolean
	portfolioSummary: any
	summaryError?: any
}

function errorText(error: any): string | undefined {
	if (error === undefined || error === null) {
		return undefined
	}
	if (typeof error === 'string') {
		return error
	}
	return error.message ?? String(error)
}

export function usePortfolioListZones({
	onCreateClick,
	tableComponent,
	isLoading,
	portfolioSummary,
	summaryError,
}: UsePortfolioListZonesArgs): PortfolioListZones {
	const currency = useCurrency()

	return {
		summary: (
			<EmissionsSummaryPanelModule
				carbonSummary={{
					intensityRatio: String(portfolioSummary?.intensity ?? 0),
					localIntensityRatio: String(portfolioSummary?.intensity ?? 0),
					scope1Total: String(portfolioSummary?.scope1Total ?? 0),
					scope2Total: String(portfolioSummary?.scope2Total ?? 0),
					scope3Total: String(portfolioSummary?.scope3Total ?? 0),
					scope1Completion: String(portfolioSummary?.scope1Completion ?? 0),
					scope2Completion: String(portfolioSummary?.scope2Completion ?? 0),
					scope3Completion: String(portfolioSummary?.scope3Completion ?? 0),
					totalCompletion: String(portfolioSummary?.totalCompletion ?? 0),
				} as CarbonAccountSummary}
				totalEmissions={portfolioSummary?.totalEmissions}
				intensityRatioUnit={`${getCurrencySymbol(currency)} of all portfolios value`}
				loading={isLoading && !portfolioSummary}
				error={errorText(summaryError)}
			/>
		),
		actions: (
			<Button
				requiresWrite
				type='Primary'
				text='Create portfolio'
				hasTrailingIcon
				icon='fa-solid fa-plus'
				size='sm'
				onClick={onCreateClick}
			/>
		),
		table: tableComponent,
	}
}

